import { jsx as _jsx } from "react/jsx-runtime";
import cs from "classnames";
export function Bullet(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: cs("max-w-max tracking-wider text-xs rounded truncate", "px-2 font-semibold bg-gray-600/10 py-[4px] dark:bg-white/10"),
        children: children
    });
}
